// Button ATC in preview popup
window.customallHandlePreviewAddToCart = true;
window.cartType = 'mini-cart';

function inkyboxParseLineItemProperties(item) {
  if (!item || !item.properties) return {};
  if (typeof item.properties === 'object' && !Array.isArray(item.properties)) return item.properties;
  if (typeof item.properties === 'string') {
    try {
      const parsed = JSON.parse(item.properties);
      return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
    } catch (error) {
      return {};
    }
  }
  return {};
}

function inkyboxParseFirstPrintFileUrl(printFiles) {
  if (!printFiles) return '';
  try {
    const parsed = typeof printFiles === 'string' ? JSON.parse(printFiles) : printFiles;
    if (Array.isArray(parsed) && parsed[0] && parsed[0].url) return parsed[0].url;
    if (parsed && parsed.url) return parsed.url;
  } catch (error) {}
  return '';
}

function inkyboxExtractUrl(value) {
  if (!value) return '';
  if (Array.isArray(value)) {
    for (const item of value) {
      const nested = inkyboxExtractUrl(item);
      if (nested) return nested;
    }
    return '';
  }
  if (typeof value === 'object') {
    return (
      inkyboxExtractUrl(value.preview) ||
      inkyboxExtractUrl(value.preview_url) ||
      inkyboxExtractUrl(value.image) ||
      inkyboxExtractUrl(value.url) ||
      inkyboxExtractUrl(value.src) ||
      ''
    );
  }
  const text = String(value || '')
    .replace(/\\\//g, '/')
    .replace(/&amp;/g, '&')
    .replace(/&quot;/g, '"')
    .replace(/&#34;/g, '"')
    .replace(/\\u0026/g, '&');
  const match = text.match(/https?:\/\/[^\s"'<>\\\]}),]+/i);
  if (!match) return '';
  const url = match[0];
  if (/\/products\/|sf_private_access_tokens/i.test(url)) return '';
  return url;
}

function inkyboxGetPreviewImageUrl(item) {
  const props = inkyboxParseLineItemProperties(item);
  return (
    inkyboxExtractUrl(props._customall_preview) ||
    inkyboxExtractUrl(props['_customall-preview']) ||
    inkyboxExtractUrl(props.customallpreview) ||
    inkyboxParseFirstPrintFileUrl(props._print_files) ||
    inkyboxExtractUrl(props._customall_print_file) ||
    inkyboxExtractUrl(props.customallprint_file) ||
    inkyboxExtractUrl(props._customall_print_file_2) ||
    inkyboxExtractUrl(props._customall_print_file_3) ||
    inkyboxExtractUrl(props._customall_print_file_4) ||
    inkyboxExtractUrl(props._inkybox_cart_preview) ||
    inkyboxExtractUrl(props._custom_preview) ||
    inkyboxExtractUrl(props['_custom-preview']) ||
    inkyboxExtractUrl(props['_cm-thumb-url']) ||
    inkyboxExtractUrl(props._customix_preview) ||
    inkyboxExtractUrl(props.customix_preview) ||
    inkyboxExtractUrl(props._preview) ||
    inkyboxExtractUrl(props.preview) ||
    inkyboxExtractUrl(props._customall_artwork_preview) ||
    inkyboxExtractUrl(props._custom_production_url) ||
    inkyboxExtractUrl(props['_custom-production-url']) ||
    inkyboxExtractUrl(props._customix_design) ||
    inkyboxExtractUrl(props.customix_design) ||
    inkyboxExtractUrl(props._customily_preview) ||
    inkyboxExtractUrl(props['_customily-preview']) ||
    ''
  );
}

function inkyboxGetLargePreviewImageUrl(item) {
  const props = inkyboxParseLineItemProperties(item);
  return (
    inkyboxExtractUrl(props._customall_preview) ||
    inkyboxExtractUrl(props['_customall-preview']) ||
    inkyboxExtractUrl(props.customallpreview) ||
    inkyboxExtractUrl(props['_cm-print-file-1']) ||
    inkyboxExtractUrl(props['_cm-print-file-2']) ||
    inkyboxExtractUrl(props._inkybox_cart_preview) ||
    inkyboxExtractUrl(props._customall_print_file) ||
    inkyboxExtractUrl(props.customallprint_file) ||
    inkyboxExtractUrl(props._customall_print_file_2) ||
    inkyboxExtractUrl(props._customall_print_file_3) ||
    inkyboxExtractUrl(props._customall_print_file_4) ||
    inkyboxExtractUrl(props._customall_artwork_preview) ||
    inkyboxExtractUrl(props._custom_production_url) ||
    inkyboxExtractUrl(props['_custom-production-url']) ||
    inkyboxParseFirstPrintFileUrl(props._print_files) ||
    inkyboxGetPreviewImageUrl(item)
  );
}

function inkyboxGetLineItemImageUrl(item) {
  return inkyboxGetPreviewImageUrl(item) || item && item.image || '';
}

function inkyboxGetCurrentPagePreviewUrl() {
  const previewButtonSelectors = [
    '.ctm-customize-product button.btn.btn-preview',
    '#customily-preview-button',
    '#sticky-customily-preview-button',
    'button[id*="preview-button"]',
    'a[id*="preview-button"]',
    'button[class*="preview"]',
  ];

  for (const selector of previewButtonSelectors) {
    const button = document.querySelector(selector);
    if (!button) continue;
    const url =
      inkyboxExtractUrl(button.getAttribute('data-preview-url')) ||
      inkyboxExtractUrl(button.getAttribute('data-print-url')) ||
      inkyboxExtractUrl(button.getAttribute('href')) ||
      '';
    if (url) return url;
  }

  const scopedPreviewImages = Array.from(document.querySelectorAll(
    '.ctm-customize-product img[src], .ctm-customize-product canvas, .ctm-customize-product [class*="preview"] img[src], .customall-wrapper img[src], .customall-wrapper canvas'
  ));

  for (const node of scopedPreviewImages) {
    if (node.closest('[class*="upload"], [class*="Upload"], [class*="uploader"], [class*="image-upload"], [class*="ImageUpload"]')) continue;
    if (node.tagName === 'CANVAS') {
      try {
        const dataUrl = node.toDataURL('image/png');
        if (dataUrl && dataUrl !== 'data:,') return dataUrl;
      } catch (error) {}
      continue;
    }
    const src = node.getAttribute('src') || '';
    if (src && !/placeholder|loading|spinner/i.test(src)) return src;
  }

  const previewImages = Array.from(document.querySelectorAll(
    '.cm-absolute img[src^="blob:"], .cm-absolute img[src*="cloudfront.net/customizations"], [class*="preview"] img[src^="blob:"], [class*="preview"] img[src*="cloudfront.net/customizations"]'
  ));

  for (const image of previewImages) {
    if (image.closest('[class*="upload"], [class*="Upload"], [class*="uploader"], [class*="image-upload"], [class*="ImageUpload"]')) continue;
    const src = image.getAttribute('src') || '';
    if (src) return src;
  }

  return '';
}

function inkyboxIsAddOnLineItem(item) {
  const props = inkyboxParseLineItemProperties(item);
  return (
    props._inkybox_item_type === 'addon' ||
    props._inkybox_parent_key ||
    props._parentKey ||
    props._parentLineKey ||
    props._is_addon === 'true' ||
    props._addon_type === 'gift_box' ||
    props._inkybox_addon_type === 'gift_box' ||
    props._add_on_customallcustomid
  );
}

function inkyboxSafeJsonResponse(response, fallback) {
  if (!response) return Promise.resolve(fallback || null);
  return response.text().then((text) => {
    const trimmed = String(text || '').trim();
    if (!response.ok || (!trimmed.startsWith('{') && !trimmed.startsWith('['))) return fallback || null;
    try {
      return JSON.parse(trimmed);
    } catch (error) {
      return fallback || null;
    }
  });
}

function inkyboxFetchCartJson() {
  if (window.InkyboxCartGuard && typeof window.InkyboxCartGuard.fetchCartJson === 'function') {
    return window.InkyboxCartGuard.fetchCartJson();
  }
  return fetch(`${routes.cart_url}.js`, {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
    cache: 'no-store',
  }).then((response) => inkyboxSafeJsonResponse(response, null));
}

function inkyboxFetchFreshCartJson() {
  return fetch(`${routes.cart_url}.js?inkybox_ts=${Date.now()}`, {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
    cache: 'no-store',
  }).then((response) => inkyboxSafeJsonResponse(response, null));
}

function inkyboxFetchCartSections(sectionIds) {
  if (window.InkyboxCartGuard && typeof window.InkyboxCartGuard.fetchCartSections === 'function') {
    return window.InkyboxCartGuard.fetchCartSections(sectionIds);
  }
  return fetch(`${routes.cart_url}?sections=${sectionIds.join(',')}`, {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
    cache: 'no-store',
  }).then((response) => inkyboxSafeJsonResponse(response, {}));
}

function inkyboxGetCustomallId(item) {
  return inkyboxParseLineItemProperties(item)._customallcustomid || '';
}

function inkyboxGetCustomixId(item) {
  const props = inkyboxParseLineItemProperties(item);
  return props['_cm-customization-id'] || props._cm_customization_id || '';
}

function inkyboxIsLikelyCustomItem(item) {
  const props = inkyboxParseLineItemProperties(item);
  return Boolean(
    props._customallcustomid ||
    props._customall_preview ||
    props['_customall-preview'] ||
    props.customallpreview ||
    props._print_files ||
    props.customallprint_file ||
    props._customix_preview ||
    props.customix_preview ||
    props['_cm-customization-id'] ||
    props._cm_customization_id ||
    props._customily_preview ||
    props['_customily-preview']
  );
}

function inkyboxHasPreviewProperty(item) {
  return !!inkyboxGetPreviewImageUrl(item);
}

function inkyboxResolveMainItemFromPayload(payload, cartItems) {
  const callbackItems = Array.isArray(payload && payload.items) ? payload.items : payload ? [payload] : [];
  const mainFromCallback = callbackItems.find((item) => !inkyboxIsAddOnLineItem(item));
  const items = Array.isArray(cartItems) ? cartItems : [];
  const pendingCustomixId = window.__inkyboxPendingCustomixId || '';

  if (pendingCustomixId) {
    const byPendingCustomixId = items.slice().reverse().find((item) => {
      return !inkyboxIsAddOnLineItem(item) && inkyboxGetCustomixId(item) === pendingCustomixId;
    });
    if (byPendingCustomixId) {
      window.__inkyboxPendingCustomixId = '';
      return byPendingCustomixId;
    }
  }

  if (mainFromCallback) {
    if (mainFromCallback.key) {
      const byKey = items.find((item) => item.key === mainFromCallback.key);
      if (byKey) return byKey;
    }
    const customallId = inkyboxGetCustomallId(mainFromCallback);
    if (customallId) {
      const byCustomallId = items.find((item) => !inkyboxIsAddOnLineItem(item) && inkyboxGetCustomallId(item) === customallId);
      if (byCustomallId) return byCustomallId;
    }
    const customixId = inkyboxGetCustomixId(mainFromCallback);
    if (customixId) {
      const byCustomixId = items.slice().reverse().find((item) => {
        return !inkyboxIsAddOnLineItem(item) && inkyboxGetCustomixId(item) === customixId;
      });
      if (byCustomixId) return byCustomixId;
    }
    const variantId = Number(mainFromCallback.variant_id || mainFromCallback.id);
    if (variantId) {
      const matchingVariantItems = items.slice().reverse().filter((item) => {
        return !inkyboxIsAddOnLineItem(item) && Number(item.variant_id || item.id) === variantId;
      });
      const byVariant = matchingVariantItems.find(inkyboxHasPreviewProperty) || matchingVariantItems[0];
      if (byVariant) return byVariant;
    }
    return mainFromCallback;
  }

  return items.slice().reverse().find((item) => !inkyboxIsAddOnLineItem(item)) || null;
}

function updateInkyboxCartNotification(cartItems, cartNotification) {
  const sectionIds = ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];

  Promise.all([inkyboxFetchCartJson(), inkyboxFetchCartSections(sectionIds)])
    .then(([cartJson, sections]) => {
      const mainItem = inkyboxResolveMainItemFromPayload(cartItems, cartJson && cartJson.items);
      const parsedState = Object.assign({}, mainItem || cartItems || {}, {
        items: cartJson && cartJson.items || [],
        sections: sections || {},
      });

      if (cartNotification.classList.contains('is-empty')) cartNotification.classList.remove('is-empty');
      if (typeof cartNotification.renderContents === 'function') {
        cartNotification.renderContents(parsedState);
      } else if (typeof cartNotification.open === 'function') {
        cartNotification.open();
      }
    })
    .catch((error) => {
      console.error('Error updating cart notification:', error);
      if (typeof cartNotification.open === 'function') cartNotification.open();
    });
}

function updateInkyboxCartDrawer(cartDrawer) {
  const sectionIds = ['cart-drawer', 'cart-icon-bubble'];
  const sectionQuery = {
    'cart-drawer': { source: 'cart-drawer', target: 'cart-drawer' },
    'cart-icon-bubble': { source: '#shopify-section-cart-icon-bubble', target: '#cart-icon-bubble' },
  };

  inkyboxFetchCartSections(sectionIds)
    .then((sections) => {
      for (const sectionId of sectionIds) {
        const htmlString = sections[sectionId];
        if (!htmlString) continue;
        const html = new DOMParser().parseFromString(htmlString, 'text/html');
        const sourceElement = html.querySelector(sectionQuery[sectionId].source);
        const targetElement = document.querySelector(sectionQuery[sectionId].target);
        if (!targetElement || !sourceElement) continue;
        if (sectionId === 'cart-icon-bubble') targetElement.innerHTML = sourceElement.innerHTML;
        else targetElement.replaceWith(sourceElement);
      }

      const themeCart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (themeCart && themeCart.classList.contains('is-empty')) themeCart.classList.remove('is-empty');
      if (window.initCartDrawerCountdown) window.initCartDrawerCountdown({ reset: true });
      if (themeCart && typeof themeCart.open === 'function') themeCart.open();
    })
    .catch((error) => console.error('Error updating cart drawer:', error));
}

function inkyboxEscapeHtml(value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

function inkyboxFormatMoney(cents) {
  const amount = Math.max(0, Number(cents || 0)) / 100;
  return `$${amount.toFixed(2)} USD`;
}

function inkyboxGetDisplaySize(item) {
  const options = Array.isArray(item && item.options_with_values) ? item.options_with_values : [];
  const sizeOption = options.find((option) => String(option.name || '').toLowerCase() === 'size');
  if (sizeOption && sizeOption.value) return sizeOption.value;
  const variantTitle = String(item && item.variant_title || '');
  if (variantTitle && variantTitle.toLowerCase() !== 'default title') return variantTitle.split(' / ')[0];
  return '';
}

function inkyboxEnsureAddToCartPopup() {
  let popup = document.getElementById('inkybox-add-to-cart-popup');
  if (popup) return popup;

  popup = document.createElement('div');
  popup.id = 'inkybox-add-to-cart-popup';
  popup.className = 'inkybox-atc-popup';
  popup.setAttribute('aria-hidden', 'true');
  popup.innerHTML = `
    <div class="inkybox-atc-popup__overlay" data-inkybox-atc-close></div>
    <div class="inkybox-atc-popup__dialog" role="dialog" aria-modal="true" aria-labelledby="inkybox-atc-popup-title">
      <button type="button" class="inkybox-atc-popup__close" data-inkybox-atc-close aria-label="Close">&times;</button>
      <p class="inkybox-atc-popup__status" id="inkybox-atc-popup-title">
        <span class="inkybox-atc-popup__check" aria-hidden="true">✓</span>
        <span>Item has been added to your shopping cart</span>
      </p>
      <div class="inkybox-atc-popup__body">
        <div class="inkybox-atc-popup__media"></div>
        <div class="inkybox-atc-popup__content"></div>
      </div>
      <div class="inkybox-atc-popup__actions">
        <button type="button" class="inkybox-atc-popup__button inkybox-atc-popup__button--secondary" data-inkybox-atc-close>
          Continue Shopping
        </button>
        <a class="inkybox-atc-popup__button inkybox-atc-popup__button--primary" href="${routes.cart_url}">
          View Cart & Checkout
        </a>
      </div>
    </div>
  `;

  popup.addEventListener('click', function (event) {
    if (event.target.closest('[data-inkybox-atc-close]')) {
      event.preventDefault();
      if (popup.classList.contains('is-loading')) return;
      inkyboxCloseAddToCartPopup();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    const activePopup = document.getElementById('inkybox-add-to-cart-popup');
    if (activePopup && activePopup.classList.contains('is-loading')) return;
    inkyboxCloseAddToCartPopup();
  });

  document.body.appendChild(popup);
  return popup;
}

function inkyboxCloseAddToCartPopup() {
  const popup = document.getElementById('inkybox-add-to-cart-popup');
  if (!popup) return;
  window.clearTimeout(window.__inkyboxAtcLoadingTimeout);
  popup.classList.remove('is-open');
  popup.classList.remove('is-loading');
  popup.classList.remove('is-error');
  popup.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('inkybox-atc-popup-open');
}

function inkyboxOpenAddToCartLoadingPopup() {
  const popup = inkyboxEnsureAddToCartPopup();
  const status = popup.querySelector('.inkybox-atc-popup__status');
  const media = popup.querySelector('.inkybox-atc-popup__media');
  const content = popup.querySelector('.inkybox-atc-popup__content');
  const actions = popup.querySelector('.inkybox-atc-popup__actions');

  window.clearTimeout(window.__inkyboxAtcLoadingTimeout);
  popup.classList.add('is-open');
  popup.classList.add('is-loading');
  popup.classList.add('is-processing-only');
  popup.classList.remove('is-error');
  popup.setAttribute('aria-hidden', 'false');
  document.body.classList.add('inkybox-atc-popup-open');

  if (status) {
    status.innerHTML = `
      <span class="inkybox-atc-popup__cart-pulse" aria-hidden="true">
        <svg viewBox="0 0 24 24" focusable="false" aria-hidden="true">
          <path d="M7 18.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm10 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM4.2 4H2V2h3.7l1 4H21l-2 8H8.2l.4 1.5H19V17H7.1L4.2 4Zm3 4 .9 4h9.3l1-4H7.2Z"></path>
        </svg>
      </span>
      <span>Preparing your item...</span>
    `;
  }

  if (media) media.innerHTML = '';
  if (content) {
    content.innerHTML = `
      <div class="inkybox-atc-popup__loading">
        <p>Please wait while we add your personalized item to cart.</p>
        <div class="inkybox-atc-popup__shimmer" aria-hidden="true"></div>
      </div>
    `;
  }
  if (actions) actions.setAttribute('hidden', 'hidden');

  window.__inkyboxAtcLoadingTimeout = window.setTimeout(() => {
    const activePopup = document.getElementById('inkybox-add-to-cart-popup');
    if (!activePopup || !activePopup.classList.contains('is-loading')) return;
    inkyboxShowAddToCartError('This is taking longer than expected. Please wait a moment or try again.');
  }, 10000);
}

function inkyboxShowAddToCartError(message) {
  const popup = inkyboxEnsureAddToCartPopup();
  const status = popup.querySelector('.inkybox-atc-popup__status');
  const media = popup.querySelector('.inkybox-atc-popup__media');
  const content = popup.querySelector('.inkybox-atc-popup__content');
  const actions = popup.querySelector('.inkybox-atc-popup__actions');

  window.clearTimeout(window.__inkyboxAtcLoadingTimeout);
  popup.classList.add('is-open');
  popup.classList.remove('is-loading');
  popup.classList.remove('is-processing-only');
  popup.classList.add('is-error');
  popup.setAttribute('aria-hidden', 'false');
  document.body.classList.add('inkybox-atc-popup-open');

  if (status) {
    status.innerHTML = `
      <span class="inkybox-atc-popup__check" aria-hidden="true">!</span>
      <span>Unable to add item</span>
    `;
  }
  if (media) media.innerHTML = '';
  if (content) {
    content.innerHTML = `<p class="inkybox-atc-popup__error">${inkyboxEscapeHtml(message || 'Please try again.')}</p>`;
  }
  if (actions) actions.removeAttribute('hidden');
}

function inkyboxTextLooksLikeAddToCart(value) {
  const text = String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  if (!text) return false;
  if (text.includes('preview') || text.includes('view cart') || text.includes('checkout') || text.includes('continue')) return false;
  return text.includes('add to cart') || text.includes('add cart') || text === 'add';
}

const inkyboxValidatedPersonalizerAddToCartButtons = new WeakSet();
const inkyboxPendingPersonalizerAddToCartButtons = new WeakSet();

function inkyboxGetDirectPersonalizerAddToCartButton(element) {
  const control = element && element.closest && element.closest('#personalized-form button.btn-add-to-cart');
  if (!control || control.disabled || control.getAttribute('aria-disabled') === 'true') return null;
  return control;
}

function inkyboxFocusFirstPersonalizerError(root) {
  const firstError = root && root.querySelector('.ant-form-item-control.has-error');
  if (!firstError) return false;

  const focusTarget = firstError.querySelector('input, textarea, select, button, [tabindex]:not([tabindex="-1"])');
  const scrollTarget = firstError.closest('.ant-form-item') || firstError;
  scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
  if (focusTarget && typeof focusTarget.focus === 'function') {
    focusTarget.focus({ preventScroll: true });
  }
  return true;
}

function inkyboxGetPersonalizerValidationState(root) {
  const requiredLabels = Array.from(root.querySelectorAll('label.ant-form-item-required'));
  if (!requiredLabels.length) return 'valid';

  const controls = requiredLabels.map(function (label) {
    const item = label.closest('.ant-form-item');
    return item && item.querySelector('.ant-form-item-control');
  });
  if (controls.some((control) => control && control.classList.contains('has-error'))) return 'invalid';
  if (controls.every((control) => control && control.classList.contains('has-success'))) return 'valid';
  return 'pending';
}

function inkyboxReplayAddToCartAfterPreviewCloses(addToCartButton, attempt) {
  const previewCloseButton = document.querySelector(
    '.vm--modal[aria-expanded="true"] .preview-wrapper .preview-header .close'
  );
  if (previewCloseButton) {
    previewCloseButton.click();
    window.setTimeout(function () {
      inkyboxPendingPersonalizerAddToCartButtons.delete(addToCartButton);
      inkyboxValidatedPersonalizerAddToCartButtons.add(addToCartButton);
      addToCartButton.click();
    }, 50);
    return;
  }
  if (attempt < 6) {
    window.setTimeout(function () {
      inkyboxReplayAddToCartAfterPreviewCloses(addToCartButton, attempt + 1);
    }, 25);
    return;
  }

  inkyboxPendingPersonalizerAddToCartButtons.delete(addToCartButton);
  inkyboxValidatedPersonalizerAddToCartButtons.add(addToCartButton);
  addToCartButton.click();
}

function inkyboxContinueAfterPersonalizerValidation(root, addToCartButton, attempt) {
  const state = inkyboxGetPersonalizerValidationState(root);
  if (state === 'invalid') {
    inkyboxPendingPersonalizerAddToCartButtons.delete(addToCartButton);
    inkyboxFocusFirstPersonalizerError(root);
    return;
  }
  if (state === 'valid') {
    inkyboxReplayAddToCartAfterPreviewCloses(addToCartButton, 0);
    return;
  }
  if (attempt >= 20) {
    inkyboxPendingPersonalizerAddToCartButtons.delete(addToCartButton);
    return;
  }

  window.setTimeout(function () {
    inkyboxContinueAfterPersonalizerValidation(root, addToCartButton, attempt + 1);
  }, 50);
}

document.addEventListener('click', function (event) {
  if (window.__inkyboxCartEditModalActive) return;

  const addToCartButton = inkyboxGetDirectPersonalizerAddToCartButton(event.target);
  if (!addToCartButton) return;
  if (inkyboxValidatedPersonalizerAddToCartButtons.has(addToCartButton)) {
    inkyboxValidatedPersonalizerAddToCartButtons.delete(addToCartButton);
    return;
  }
  if (inkyboxPendingPersonalizerAddToCartButtons.has(addToCartButton)) {
    event.preventDefault();
    event.stopImmediatePropagation();
    return;
  }

  const personalizerRoot = addToCartButton.closest('#personalized-form');
  const previewButton = personalizerRoot && personalizerRoot.querySelector('button.btn.btn-preview');
  if (!previewButton || previewButton.disabled || previewButton.getAttribute('aria-disabled') === 'true') return;
  if (inkyboxGetPersonalizerValidationState(personalizerRoot) === 'valid') return;

  event.preventDefault();
  event.stopImmediatePropagation();
  inkyboxPendingPersonalizerAddToCartButtons.add(addToCartButton);
  previewButton.click();

  inkyboxContinueAfterPersonalizerValidation(personalizerRoot, addToCartButton, 0);
}, true);

function inkyboxIsEarlyAddToCartTrigger(element) {
  const control = element && element.closest && element.closest('button, a, input, [role="button"]');
  if (!control || control.closest('.inkybox-atc-popup')) return false;
  if (control.disabled || control.getAttribute('aria-disabled') === 'true') return false;

  const haystack = [
    control.textContent,
    control.value,
    control.getAttribute('aria-label'),
    control.getAttribute('title'),
    control.getAttribute('id'),
    control.getAttribute('class'),
    control.getAttribute('data-action'),
    control.getAttribute('data-testid'),
  ].join(' ');

  if (/preview|customize|design/i.test(haystack)) return false;
  if (inkyboxTextLooksLikeAddToCart(haystack)) return true;
  if (control.matches('[name="add"], [type="submit"][name="add"]')) return true;

  const form = control.closest('form');
  return !!(form && form.matches('[data-type="add-to-cart-form"]') && control.matches('[type="submit"], button:not([type]), [role="button"][aria-label*="Add" i]'));
}

document.addEventListener('click', function (event) {
  if (window.__inkyboxCartEditModalActive) return;
  if (!inkyboxIsEarlyAddToCartTrigger(event.target)) return;
  inkyboxOpenAddToCartLoadingPopup();
}, true);

function inkyboxOpenAddToCartPopup(item) {
  if (!item) return;
  const addedProductId = item.product_id || item.productId;
  if (addedProductId) {
    document.dispatchEvent(new CustomEvent('inkybox:cart-add-success', {
      detail: { productId: String(addedProductId) },
    }));
  }
  const popup = inkyboxEnsureAddToCartPopup();
  const status = popup.querySelector('.inkybox-atc-popup__status');
  const media = popup.querySelector('.inkybox-atc-popup__media');
  const content = popup.querySelector('.inkybox-atc-popup__content');
  const actions = popup.querySelector('.inkybox-atc-popup__actions');
  const linePreviewUrl = inkyboxGetPreviewImageUrl(item);
  const currentPagePreviewUrl = linePreviewUrl ? '' : window.__inkyboxCurrentPagePreviewUrl || inkyboxGetCurrentPagePreviewUrl();
  const previewUrl = linePreviewUrl || currentPagePreviewUrl;
  const largePreviewUrl = inkyboxGetLargePreviewImageUrl(item) || previewUrl;
  const imageUrl = previewUrl || item && item.image || '';
  const size = inkyboxGetDisplaySize(item);
  const price = item.final_price || item.price || item.original_price || 0;

  window.clearTimeout(window.__inkyboxAtcLoadingTimeout);
  if (status) {
    status.innerHTML = `
      <span class="inkybox-atc-popup__check" aria-hidden="true">&#10003;</span>
      <span>Item has been added to your shopping cart</span>
    `;
  }
  media.innerHTML = imageUrl
    ? `<img src="${inkyboxEscapeHtml(imageUrl)}" alt="${inkyboxEscapeHtml(item.product_title || item.title)}" loading="lazy">`
    : '';
  content.innerHTML = `
    <h3 class="inkybox-atc-popup__title">${inkyboxEscapeHtml(item.product_title || item.title)}</h3>
    ${size ? `<p class="inkybox-atc-popup__meta"><span>Size:</span> ${inkyboxEscapeHtml(size)}</p>` : ''}
    <p class="inkybox-atc-popup__meta"><span>Quantity:</span> ${inkyboxEscapeHtml(item.quantity || 1)}</p>
    <p class="inkybox-atc-popup__price">${inkyboxEscapeHtml(inkyboxFormatMoney(price))}</p>
    ${largePreviewUrl ? `<button type="button" class="inkybox-atc-popup__preview inkybox-preview-button" data-preview-url="${inkyboxEscapeHtml(largePreviewUrl)}" data-preview-alt="${inkyboxEscapeHtml(item.product_title || item.title)}">Preview</button>` : ''}
  `;
  if (actions) actions.removeAttribute('hidden');

  popup.classList.add('is-open');
  popup.classList.remove('is-loading');
  popup.classList.remove('is-processing-only');
  popup.classList.remove('is-error');
  popup.setAttribute('aria-hidden', 'false');
  document.body.classList.add('inkybox-atc-popup-open');
  window.__inkyboxCurrentPagePreviewUrl = '';
}

function updateInkyboxCartIcon(sections) {
  const htmlString = sections && sections['cart-icon-bubble'];
  const targetElement = document.querySelector('#cart-icon-bubble');
  if (!targetElement) return false;

  if (htmlString) {
    const html = new DOMParser().parseFromString(htmlString, 'text/html');
    const sourceElement = html.querySelector('#shopify-section-cart-icon-bubble') || html.querySelector('#cart-icon-bubble');
    if (sourceElement) {
      targetElement.innerHTML = sourceElement.id === 'cart-icon-bubble' ? sourceElement.innerHTML : sourceElement.innerHTML;
      return true;
    }
  }

  return false;
}

function updateInkyboxCartIconFromCartJson(cartJson) {
  const targetElement = document.querySelector('#cart-icon-bubble');
  const count = Number(cartJson && cartJson.item_count);
  if (!targetElement || Number.isNaN(count)) return false;

  let bubble = targetElement.querySelector('.cart-count-bubble');
  if (count <= 0) {
    if (bubble) bubble.remove();
    return true;
  }

  if (!bubble) {
    bubble = document.createElement('div');
    bubble.className = 'cart-count-bubble';
    bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
    targetElement.appendChild(bubble);
  }

  const visibleCount = bubble.querySelector('[aria-hidden="true"]');
  const accessibleCount = bubble.querySelector('.visually-hidden');
  if (visibleCount) visibleCount.textContent = count < 100 ? String(count) : '';
  if (accessibleCount) accessibleCount.textContent = `${count} item${count === 1 ? '' : 's'} in cart`;
  return true;
}

function inkyboxWaitForPreviewCartItem(payload, cartJson, attempt = 0) {
  const mainItem = inkyboxResolveMainItemFromPayload(payload, cartJson && cartJson.items);
  const shouldWaitForPreview =
    mainItem &&
    !inkyboxGetPreviewImageUrl(mainItem) &&
    (inkyboxIsLikelyCustomItem(mainItem) || document.querySelector('.ctm-customize-product, .customall-wrapper'));

  if (!shouldWaitForPreview || attempt >= 5) {
    return Promise.resolve({ cartJson, mainItem });
  }

  return new Promise((resolve) => window.setTimeout(resolve, 300))
    .then(() => inkyboxFetchFreshCartJson())
    .then((nextCartJson) => inkyboxWaitForPreviewCartItem(payload, nextCartJson || cartJson, attempt + 1))
    .catch(() => ({ cartJson, mainItem }));
}

function showInkyboxAddToCartPopup(cartItems) {
  const shouldOpenPopup = !window.__inkyboxAtcPopupLastOpenedAt || Date.now() - window.__inkyboxAtcPopupLastOpenedAt >= 900;
  if (shouldOpenPopup) window.__inkyboxAtcPopupLastOpenedAt = Date.now();

  const sectionIds = ['cart-icon-bubble'];
  window.setTimeout(() => {
    Promise.all([inkyboxFetchFreshCartJson(), inkyboxFetchCartSections(sectionIds)])
      .then(([cartJson, sections]) => {
        if (!updateInkyboxCartIcon(sections)) updateInkyboxCartIconFromCartJson(cartJson);
        if (!shouldOpenPopup) return null;

        return inkyboxWaitForPreviewCartItem(cartItems, cartJson).then((result) => {
          if (result && result.cartJson && result.cartJson !== cartJson) updateInkyboxCartIconFromCartJson(result.cartJson);
          inkyboxOpenAddToCartPopup(result && result.mainItem);
        });
      })
      .catch((error) => {
        console.error('Error showing add to cart popup:', error);
        if (!shouldOpenPopup) return;
        const fallbackItem = Array.isArray(cartItems && cartItems.items) ? cartItems.items.find((item) => !inkyboxIsAddOnLineItem(item)) : cartItems;
        inkyboxOpenAddToCartPopup(fallbackItem);
      });
  }, 250);
}

window.addToCartCallback = (cartItems) => {
  if (window.__inkyboxCartEditModalActive) {
    if (window.__INKYBOX_CART_DEBUG__ === true) {
      console.log('[Inkybox cart debug] product-page-addToCartCallback-bypassed', { cartItems });
    }
    if (typeof window.trackingEditCartSuccess === 'function') {
      window.trackingEditCartSuccess();
    }
    return;
  }

  try {
    showInkyboxAddToCartPopup(cartItems);
  } catch (error) {
    console.log('error', error);
  }
};

(function installPreviewButtonLabelOverride() {
  const newText = 'Preview Your Personalized';
  const root = document.querySelector('.product__info-container') || document.documentElement;
  const previewSpanSelector = '.ctm-customize-product button.btn.btn-preview span';
  const previewButtonSelector = '.ctm-customize-product button.btn.btn-preview';
  let updateFrame = 0;

  function updateCustomallPreviewText() {
    const span = root.querySelector(previewSpanSelector);
    if (!span) return;
    if ((span.textContent || '').trim() === 'Preview') {
      span.textContent = newText;
      const btn = span.closest('button');
      if (btn) btn.setAttribute('aria-label', newText);
    }
  }

  function scheduleUpdate() {
    if (updateFrame) return;
    updateFrame = window.requestAnimationFrame(function () {
      updateFrame = 0;
      updateCustomallPreviewText();
    });
  }

  updateCustomallPreviewText();
  new MutationObserver((mutations) => {
    const previewChanged = mutations.some((mutation) => {
      const target = mutation.target && mutation.target.nodeType === 1
        ? mutation.target
        : mutation.target && mutation.target.parentElement;
      if (target && (target.matches(previewButtonSelector) || target.closest(previewButtonSelector))) {
        return true;
      }

      return Array.from(mutation.addedNodes || []).some((node) => {
        if (!node || node.nodeType !== 1) return false;
        return node.matches(previewButtonSelector) || !!node.querySelector(previewButtonSelector);
      });
    });
    if (previewChanged) scheduleUpdate();
  }).observe(root, { childList: true, subtree: true });
})();

(function initInkyboxMobileStickyPreviewButton() {
  if (window.__inkyboxMobileStickyPreviewInstalled) return;
  window.__inkyboxMobileStickyPreviewInstalled = true;

  const stickyId = 'sticky-customily-preview-button';
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const visualViewport = window.visualViewport;
  const previewButtonSelectors = [
    '.ctm-customize-product button.btn.btn-preview',
    '#customily-preview-button',
    'button[id*="preview-button"]',
    'a[id*="preview-button"]',
  ];
  const previewButtonSelector = previewButtonSelectors.join(',');
  let stickyButton = null;
  let previewButton = null;
  let previewObserver = null;
  let previewStateObserver = null;
  let updateFrame = null;

  function buttonTextMatchesPreview(button) {
    const text = String(button && button.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
    return text.includes('preview your personalized') || text.includes('preview your design') || text === 'preview';
  }

  function isUsableElement(element) {
    if (!element || element.id === stickyId || !element.isConnected) return false;
    if (element.closest('.inkybox-atc-popup')) return false;
    const styles = window.getComputedStyle ? window.getComputedStyle(element) : null;
    if (styles && (styles.display === 'none' || styles.visibility === 'hidden')) return false;
    const rect = element.getBoundingClientRect && element.getBoundingClientRect();
    return !!(rect && rect.width > 1 && rect.height > 1);
  }

  function findPreviewButton() {
    const root =
      document.querySelector('.product__info-container') ||
      document.querySelector('.ctm-customize-product') ||
      document;
    for (const selector of previewButtonSelectors) {
      const match = Array.from(root.querySelectorAll(selector)).find(isUsableElement);
      if (match) return match;
    }

    return Array.from(root.querySelectorAll('button, a')).find((button) => {
      return isUsableElement(button) && buttonTextMatchesPreview(button);
    }) || null;
  }

  function getPreviewLabel() {
    const text = String(previewButton && previewButton.textContent || '').replace(/\s+/g, ' ').trim();
    return text || 'Preview Your Personalized';
  }

  function ensureStickyButton() {
    if (stickyButton && stickyButton.isConnected) return stickyButton;
    stickyButton = document.getElementById(stickyId);
    if (!stickyButton) {
      stickyButton = document.createElement('button');
      stickyButton.type = 'button';
      stickyButton.id = stickyId;
      stickyButton.className = 'inkybox-mobile-sticky-preview-button';
      stickyButton.hidden = true;
      stickyButton.setAttribute('aria-hidden', 'true');
      document.body.appendChild(stickyButton);
    }

    stickyButton.addEventListener('click', function (event) {
      event.preventDefault();
      if (!previewButton || stickyButton.disabled) return;
      previewButton.click();
    });

    return stickyButton;
  }

  function setStickyVisible(visible) {
    const button = ensureStickyButton();
    if (button.hidden === visible) button.hidden = !visible;
    const ariaHidden = visible ? 'false' : 'true';
    if (button.getAttribute('aria-hidden') !== ariaHidden) button.setAttribute('aria-hidden', ariaHidden);
    if (document.body.classList.contains('inkybox-sticky-preview-visible') !== visible) {
      document.body.classList.toggle('inkybox-sticky-preview-visible', visible);
    }
  }

  function observePreviewButton(nextButton) {
    if (previewButton === nextButton) return;
    if (previewObserver) previewObserver.disconnect();
    if (previewStateObserver) previewStateObserver.disconnect();
    previewButton = nextButton;

    if (previewButton && 'IntersectionObserver' in window) {
      previewObserver = new IntersectionObserver(scheduleUpdate, { threshold: 0.01 });
      previewObserver.observe(previewButton);
    }
    if (previewButton) {
      previewStateObserver = new MutationObserver(scheduleUpdate);
      previewStateObserver.observe(previewButton, {
        attributes: true,
        attributeFilter: ['class', 'style', 'disabled', 'aria-disabled'],
        childList: true,
        characterData: true,
        subtree: true,
      });
    }
  }

  function updateStickyState() {
    updateFrame = null;
    const nextButton = findPreviewButton();
    observePreviewButton(nextButton);

    const textFieldFocused = document.activeElement?.matches(
      'input:not([type]), input[type="text"], input[type="search"], input[type="email"], input[type="password"], input[type="url"], input[type="tel"], input[type="number"], textarea, [contenteditable="true"]'
    );
    // Scale-normalized height distinguishes a keyboard from ordinary pinch zoom.
    const layoutHeight = Math.max(window.innerHeight, document.documentElement.clientHeight);
    const keyboardOpen = textFieldFocused && visualViewport &&
      visualViewport.height * visualViewport.scale < layoutHeight - 120;
    if (!mobileQuery.matches || keyboardOpen || !previewButton || !isUsableElement(previewButton)) {
      setStickyVisible(false);
      return;
    }

    const button = ensureStickyButton();
    const label = getPreviewLabel();
    if (button.textContent !== label) button.textContent = label;
    if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
    const disabled = previewButton.disabled || previewButton.getAttribute('aria-disabled') === 'true';
    if (button.disabled !== disabled) button.disabled = disabled;

    const rect = previewButton.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    const isInViewport = rect.top < viewportHeight && rect.bottom > 0 && rect.left < viewportWidth && rect.right > 0;

    setStickyVisible(!isInViewport && !button.disabled);
  }

  function scheduleUpdate() {
    if (updateFrame) return;
    updateFrame = window.requestAnimationFrame(updateStickyState);
  }

  function init() {
    ensureStickyButton();
    updateStickyState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', scheduleUpdate);
  if (!('IntersectionObserver' in window)) {
    window.addEventListener('scroll', scheduleUpdate, { passive: true });
  }
  window.addEventListener('resize', scheduleUpdate);
  // Apply keyboard transitions directly, including when Safari delays animation frames.
  visualViewport?.addEventListener('resize', updateStickyState, { passive: true });
  document.addEventListener('focusin', scheduleUpdate);
  document.addEventListener('focusout', scheduleUpdate);
  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', scheduleUpdate);
  } else if (mobileQuery.addListener) {
    mobileQuery.addListener(scheduleUpdate);
  }

  const observerRoot = document.querySelector('.product__info-container') || document.documentElement;
  new MutationObserver((mutations) => {
    const previewButtonChanged = mutations.some((mutation) => {
      return [...mutation.addedNodes, ...mutation.removedNodes].some((node) => {
        if (node.nodeType !== 1) return false;
        return node.matches(previewButtonSelector) || node.querySelector(previewButtonSelector);
      });
    });
    if (previewButtonChanged || !previewButton || !previewButton.isConnected) scheduleUpdate();
  }).observe(observerRoot, {
    childList: true,
    subtree: true,
  });

  setTimeout(scheduleUpdate, 500);
  setTimeout(scheduleUpdate, 1500);
  setTimeout(scheduleUpdate, 3000);
})();

(function initInkyboxCustomallMediaHandoff() {
  const anchor = document.querySelector('[data-inkybox-customall-media-anchor]');
  if (!anchor) return;
  let mediaObserver = null;
  let mediaSettled = false;
  let mediaReady = false;
  let personalizationStarted = false;
  let updateFrame = 0;
  const retryTimers = [];

  const isRealMediaNode = (node) => {
    if (!node || node.nodeType !== 1) return false;
    if (node.closest('[data-inkybox-shopify-media]')) return false;
    const rect = node.getBoundingClientRect && node.getBoundingClientRect();
    const isVisible = rect && rect.width > 24 && rect.height > 24;
    if (!isVisible) return false;
    const styles = window.getComputedStyle ? window.getComputedStyle(node) : null;
    if (styles && (styles.display === 'none' || styles.visibility === 'hidden' || Number(styles.opacity) === 0)) return false;
    if (node.matches('canvas')) return node.width > 24 && node.height > 24;
    if (node.matches('iframe, video')) return true;
    if (node.matches('img[src]')) {
      const src = node.getAttribute('src') || '';
      return src && !/placeholder|loading|spinner/i.test(src) && node.complete && node.naturalWidth > 24;
    }
    return false;
  };

  const stopMediaWatching = () => {
    if (mediaObserver) {
      mediaObserver.disconnect();
      mediaObserver = null;
    }
    retryTimers.forEach((timer) => window.clearTimeout(timer));
    anchor.removeEventListener('load', scheduleUpdate, true);
    document.removeEventListener('customall-script-injected', handleScriptInjected);
  };

  const stopWatching = () => {
    stopMediaWatching();
    document.removeEventListener('click', handlePersonalizationIntent, true);
    document.removeEventListener('input', handlePersonalizationIntent, true);
    document.removeEventListener('change', handlePersonalizationIntent, true);
  };

  const showCustomallMediaWhenReady = () => {
    if (mediaSettled || !mediaReady || !personalizationStarted) return;
    anchor.classList.add('inkybox-customall-media-loaded');
    mediaSettled = true;
    stopWatching();
  };

  function handlePersonalizationIntent(event) {
    const control = event.target && event.target.closest && event.target.closest(
      '#personalized-form input, #personalized-form select, #personalized-form textarea, #personalized-form button, #personalized-form [role="button"], #personalized-form [role="combobox"], #personalized-form label, #personalized-form .customall-grid .image-item'
    );
    if (!control || control.closest('.cart-qty, .add-to-cart-group')) return;

    personalizationStarted = true;
    anchor.classList.add('inkybox-customall-media-activated');
    showCustomallMediaWhenReady();
  }

  const update = () => {
    if (mediaSettled) return;
    const realMedia = Array.from(anchor.querySelectorAll('img[src], canvas, iframe, video'))
      .some(isRealMediaNode);
    if (!realMedia) return;

    mediaReady = true;
    anchor.classList.add('inkybox-customall-media-ready');
    stopMediaWatching();
    showCustomallMediaWhenReady();
  };

  const scheduleUpdate = () => {
    if (mediaSettled) return;
    if (updateFrame) return;
    updateFrame = window.requestAnimationFrame(() => {
      updateFrame = 0;
      update();
    });
  };

  function handleScriptInjected() {
    document.querySelector('.inkybox-personalized-product')?.classList.add('inkybox-customall-mounted');
    scheduleUpdate();
    retryTimers.push(window.setTimeout(scheduleUpdate, 300));
    retryTimers.push(window.setTimeout(scheduleUpdate, 900));
  }

  document.addEventListener('customall-script-injected', handleScriptInjected);
  document.addEventListener('click', handlePersonalizationIntent, true);
  document.addEventListener('input', handlePersonalizationIntent, true);
  document.addEventListener('change', handlePersonalizationIntent, true);
  anchor.addEventListener('load', scheduleUpdate, true);
  update();
  if (!mediaSettled) {
    mediaObserver = new MutationObserver(scheduleUpdate);
    mediaObserver.observe(anchor, {
      attributes: true,
      attributeFilter: ['src', 'class', 'style'],
      childList: true,
      subtree: true,
    });
    [500, 1500, 3000, 5000, 8000].forEach((delay) => {
      retryTimers.push(window.setTimeout(scheduleUpdate, delay));
    });
  }
})();

(function initInkyboxMobileArtworkDrawer() {
  const product = document.querySelector('.inkybox-customall-product');
  const anchor = product && product.querySelector('[data-inkybox-customall-media-anchor]');
  if (!anchor) return;

  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const visualViewport = window.visualViewport;
  const supportsIntersectionObserver = 'IntersectionObserver' in window;
  let artwork = null;
  let form = null;
  let sentinel = null;
  let drawer = null;
  let nativeHost = null;
  let nativeStage = null;
  let nativeCanvas = null;
  let nativeSizeObserver = null;
  let nativeWidth = 0;
  let nativeHeight = 0;
  let closeButton = null;
  let zoomControls = null;
  let zoomOutButton = null;
  let zoomResetButton = null;
  let zoomInButton = null;
  let artworkObserver = null;
  let formObserver = null;
  let updateFrame = 0;
  let updateFallbackTimer = 0;
  let dismissed = false;
  let keyboardAdjustedField = null;
  let keyboardAlignmentTimer = 0;
  let keyboardHasAdjusted = false;
  let keyboardDismissedField = null;
  let keyboardWasOpen = false;
  let keyboardScrollEnabled = false;
  let keyboardTouch = null;
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  let keyboardPageLock = null;
  const minimumZoom = 1;
  const maximumZoom = 3;
  const zoomStep = 0.5;
  let zoomScale = minimumZoom;
  let panX = 0;
  let panY = 0;
  let activePointerId = null;
  let pointerStartX = 0;
  let pointerStartY = 0;
  let pointerStartPanX = 0;
  let pointerStartPanY = 0;
  let previewFrameWidth = window.innerWidth;
  let previewFrameHeight = 0;

  function clampPan() {
    if (!drawer || zoomScale <= minimumZoom) {
      panX = 0;
      panY = 0;
      return;
    }
    const maximumPanX = previewFrameWidth * (zoomScale - 1) / 2;
    const maximumPanY = previewFrameHeight * (zoomScale - 1) / 2;
    panX = Math.max(-maximumPanX, Math.min(maximumPanX, panX));
    panY = Math.max(-maximumPanY, Math.min(maximumPanY, panY));
  }

  function applyPreviewPan() {
    if (!nativeStage) return;
    clampPan();
    const fit = Math.min(previewFrameWidth / nativeWidth, previewFrameHeight / nativeHeight);
    nativeStage.style.setProperty('--inkybox-artwork-native-scale', fit * zoomScale);
    nativeStage.style.setProperty('--inkybox-artwork-native-x', `${panX}px`);
    nativeStage.style.setProperty('--inkybox-artwork-native-y', `${(previewFrameHeight - nativeHeight * fit * zoomScale) / 2 + panY}px`);
  }

  function applyPreviewTransform() {
    if (!drawer || !nativeStage) return;
    applyPreviewPan();
    drawer.classList.toggle('is-zoomed', zoomScale > minimumZoom);
    zoomOutButton && (zoomOutButton.disabled = zoomScale <= minimumZoom);
    zoomInButton && (zoomInButton.disabled = zoomScale >= maximumZoom);
    if (zoomResetButton) {
      zoomResetButton.disabled = zoomScale <= minimumZoom;
      zoomResetButton.textContent = `${zoomScale}\u00d7`;
      zoomResetButton.setAttribute('aria-label', `Reset preview zoom, currently ${zoomScale} times`);
    }
  }

  function setZoom(nextZoom) {
    zoomScale = Math.max(minimumZoom, Math.min(maximumZoom, nextZoom));
    applyPreviewTransform();
  }

  function resetPreviewTransform() {
    zoomScale = minimumZoom;
    panX = 0;
    panY = 0;
    activePointerId = null;
    drawer?.classList.remove('is-dragging');
    applyPreviewTransform();
  }

  function startPreviewPan(event) {
    if (zoomScale <= minimumZoom || event.button > 0) return;
    activePointerId = event.pointerId;
    pointerStartX = event.clientX;
    pointerStartY = event.clientY;
    pointerStartPanX = panX;
    pointerStartPanY = panY;
    drawer.classList.add('is-dragging');
    drawer.setPointerCapture?.(event.pointerId);
    event.preventDefault();
  }

  function movePreviewPan(event) {
    if (event.pointerId !== activePointerId) return;
    panX = pointerStartPanX + event.clientX - pointerStartX;
    panY = pointerStartPanY + event.clientY - pointerStartY;
    applyPreviewPan();
    event.preventDefault();
  }

  function endPreviewPan(event) {
    if (event.pointerId !== activePointerId) return;
    drawer.releasePointerCapture?.(event.pointerId);
    activePointerId = null;
    drawer.classList.remove('is-dragging');
  }

  function ensureDrawer() {
    if (drawer) return;
    drawer = document.createElement('div');
    drawer.className = 'inkybox-customall-artwork-drawer';
    drawer.setAttribute('aria-hidden', 'true');
    drawer.addEventListener('pointerdown', startPreviewPan);
    drawer.addEventListener('pointermove', movePreviewPan);
    drawer.addEventListener('pointerup', endPreviewPan);
    drawer.addEventListener('pointercancel', endPreviewPan);
    // Consume taps without cancelling the touch gesture that scrolls the page at 1x.
    drawer.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
    });
    drawer.addEventListener('mousedown', (event) => event.preventDefault());

    zoomControls = document.createElement('div');
    zoomControls.className = 'inkybox-customall-artwork-drawer__zoom';
    zoomControls.setAttribute('role', 'group');
    zoomControls.setAttribute('aria-label', 'Preview zoom controls');
    zoomControls.hidden = true;

    zoomOutButton = document.createElement('button');
    zoomOutButton.type = 'button';
    zoomOutButton.className = 'inkybox-customall-artwork-drawer__zoom-button';
    zoomOutButton.setAttribute('aria-label', 'Zoom preview out');
    zoomOutButton.textContent = '\u2212';
    zoomOutButton.addEventListener('click', () => setZoom(zoomScale - zoomStep));

    zoomResetButton = document.createElement('button');
    zoomResetButton.type = 'button';
    zoomResetButton.className = 'inkybox-customall-artwork-drawer__zoom-button inkybox-customall-artwork-drawer__zoom-reset';
    zoomResetButton.addEventListener('click', resetPreviewTransform);

    zoomInButton = document.createElement('button');
    zoomInButton.type = 'button';
    zoomInButton.className = 'inkybox-customall-artwork-drawer__zoom-button';
    zoomInButton.setAttribute('aria-label', 'Zoom preview in');
    zoomInButton.textContent = '+';
    zoomInButton.addEventListener('click', () => setZoom(zoomScale + zoomStep));

    zoomControls.append(zoomInButton, zoomResetButton, zoomOutButton);
    closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.className = 'inkybox-customall-artwork-drawer__close';
    closeButton.setAttribute('aria-label', 'Close floating preview');
    closeButton.hidden = true;
    closeButton.innerHTML = `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">
        <path d="M5 5 19 19M19 5 5 19"/>
      </svg>
    `;
    closeButton.addEventListener('click', () => {
      dismissed = true;
      hideDrawer();
    });
    document.body.appendChild(drawer);
    document.body.appendChild(zoomControls);
    document.body.appendChild(closeButton);
    applyPreviewTransform();
  }

  function releaseNativeArtwork() {
    nativeSizeObserver?.disconnect();
    nativeSizeObserver = null;
    nativeHost?.classList.remove('inkybox-customall-artwork-native-host');
    nativeStage?.classList.remove('inkybox-customall-artwork-native-stage');
    for (const name of ['scale', 'x', 'y']) {
      nativeStage?.style.removeProperty(`--inkybox-artwork-native-${name}`);
    }
    for (const name of ['width', 'height', 'top']) {
      nativeHost?.style.removeProperty(`--inkybox-artwork-native-${name}`);
    }
    if (anchor.classList.contains('inkybox-native-artwork-active')) {
      anchor.classList.remove('inkybox-native-artwork-active');
    }
    anchor.style.removeProperty('--inkybox-artwork-source-height');
    nativeHost = null;
    nativeStage = null;
    nativeCanvas = null;
  }

  function bindNativeArtwork() {
    const nextCanvas = artwork?.querySelector('.main-carousel .embla__slide.current-slide canvas') ||
      artwork?.querySelector('.main-carousel canvas');
    const nextHost = nextCanvas?.closest('.pack-canvas-host');
    const nextStage = nextCanvas?.closest('.konvajs-content');
    if (!nextHost || !nextStage || !nextCanvas.width || !nextCanvas.height) {
      releaseNativeArtwork();
      return false;
    }
    if (nativeCanvas !== nextCanvas) {
      releaseNativeArtwork();
      // Reserve the source slot before fixing its host; never reparent app nodes.
      const sourceHeight = artwork.getBoundingClientRect().height;
      nativeHost = nextHost;
      nativeStage = nextStage;
      nativeCanvas = nextCanvas;
      anchor.style.setProperty('--inkybox-artwork-source-height', `${sourceHeight}px`);
      if ('ResizeObserver' in window) {
        nativeSizeObserver = new ResizeObserver(scheduleDrawerUpdate);
        nativeSizeObserver.observe(nativeCanvas);
      }
    }
    // Layout sizes are deliberately unscaled: scaling an Embla ancestor corrupts its snap distances.
    // Some app CSS collapses the stage's layout height to zero while its absolute canvas is still square.
    const canvasStyle = window.getComputedStyle(nativeCanvas);
    nativeWidth = parseFloat(canvasStyle.width);
    nativeHeight = parseFloat(canvasStyle.height);
    if (!nativeWidth || !nativeHeight || !anchor.clientWidth) {
      releaseNativeArtwork();
      return false;
    }
    nativeHost.style.setProperty('--inkybox-artwork-native-width', `${anchor.getBoundingClientRect().width}px`);
    nativeHost.classList.add('inkybox-customall-artwork-native-host');
    nativeStage.classList.add('inkybox-customall-artwork-native-stage');
    if (!anchor.classList.contains('inkybox-native-artwork-active')) {
      anchor.classList.add('inkybox-native-artwork-active');
    }
    return true;
  }

  function ensureSentinel() {
    if (!artwork || sentinel?.isConnected) return;
    sentinel = document.createElement('span');
    sentinel.className = 'inkybox-customall-artwork-drawer-sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    artwork.before(sentinel);
  }

  function hideDrawer() {
    cancelKeyboardAlignment();
    releaseKeyboardPage();
    resetPreviewTransform();
    drawer?.classList.remove('is-visible');
    drawer?.setAttribute('aria-hidden', 'true');
    if (zoomControls) zoomControls.hidden = true;
    if (closeButton) closeButton.hidden = true;
    releaseNativeArtwork();
  }

  function getFocusedTextField() {
    const activeElement = document.activeElement;
    if (!form?.contains(activeElement)) return null;
    return activeElement.matches('input:not([type]), input[type="text"], input[type="email"], input[type="tel"], input[type="number"], textarea, [contenteditable="true"]')
      ? activeElement
      : null;
  }

  function keyboardTouchPoint(touch) {
    // Safari can shift client coordinates when a focused page scrolls. Screen deltas stay physical.
    return {
      x: Number.isFinite(touch.screenX) ? touch.screenX : touch.clientX,
      y: Number.isFinite(touch.screenY) ? touch.screenY : touch.clientY,
    };
  }

  function lockKeyboardPage() {
    if (!isIOS || keyboardPageLock || !keyboardScrollEnabled) return;
    const body = document.body;
    const properties = ['position', 'top', 'left', 'right', 'width'];
    keyboardPageLock = {
      x: window.scrollX,
      y: window.scrollY,
      styles: properties.map((name) => [name, body.style.getPropertyValue(name), body.style.getPropertyPriority(name)]),
    };
    // Safari pans its focused root viewport even after touchmove is cancelled.
    // Keep that root stationary and move only the existing document content.
    body.style.position = 'fixed';
    body.style.top = `${-keyboardPageLock.y}px`;
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
  }

  function releaseKeyboardPage() {
    if (!keyboardPageLock) return;
    const lock = keyboardPageLock;
    keyboardPageLock = null;
    for (const [name, value, priority] of lock.styles) {
      if (value) document.body.style.setProperty(name, value, priority);
      else document.body.style.removeProperty(name);
    }
    // Restore layout before Safari applies the saved document offset.
    document.body.getBoundingClientRect();
    window.scrollTo(lock.x, lock.y);
  }

  function scrollArtworkPageBy(delta) {
    if (!keyboardPageLock) {
      window.scrollBy(0, delta);
      return;
    }
    const contentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight);
    const maximum = Math.max(0, contentHeight - (visualViewport?.height || window.innerHeight));
    keyboardPageLock.y = Math.max(0, Math.min(maximum, keyboardPageLock.y + delta));
    document.body.style.top = `${-keyboardPageLock.y}px`;
  }

  function startKeyboardScroll(event) {
    keyboardTouch = null;
    if (event.touches.length !== 1 || !getFocusedTextField() || !drawer?.classList.contains('is-visible')) return;
    if (zoomScale > minimumZoom && drawer.contains(event.target)) return;
    if (event.target.closest?.('select, [role="dialog"], [role="listbox"], .ant-select-dropdown')) return;
    if (window.getSelection()?.type === 'Range') return;
    if (event.target.matches?.('input, textarea') && event.target.selectionStart !== event.target.selectionEnd) return;
    // Leave app-owned scroll areas and text selection to their native handlers.
    for (let node = event.target; node && node !== document.body; node = node.parentElement) {
      if (node.scrollHeight > node.clientHeight + 1 && /auto|scroll/.test(getComputedStyle(node).overflowY)) return;
    }
    const touch = keyboardTouchPoint(event.touches[0]);
    keyboardTouch = { x: touch.x, y: touch.y, startedAt: performance.now(), scrolling: false };
  }

  function moveKeyboardScroll(event) {
    if (!keyboardTouch || event.touches.length !== 1 || !event.cancelable || event.defaultPrevented) return;
    if (!getFocusedTextField() || (!keyboardTouch.scrolling && !drawer?.classList.contains('is-visible'))) return;
    const touch = keyboardTouchPoint(event.touches[0]);
    const dx = touch.x - keyboardTouch.x;
    const dy = touch.y - keyboardTouch.y;
    if (!keyboardTouch.scrolling) {
      if (performance.now() - keyboardTouch.startedAt > 400) {
        keyboardTouch = null;
        return;
      }
      if (Math.max(Math.abs(dx), Math.abs(dy)) < 6) return;
      if (Math.abs(dx) > Math.abs(dy)) {
        keyboardTouch = null;
        return;
      }
      keyboardTouch.scrolling = true;
    }
    keyboardAdjustedField = getFocusedTextField();
    keyboardHasAdjusted = true;
    cancelKeyboardAlignment();
    // Native keyboard panning runs ahead of viewport events and makes fixed artwork judder.
    // Scroll the document directly for this gesture; taps and horizontal/zoom gestures stay native.
    event.preventDefault();
    scrollArtworkPageBy(-dy / (visualViewport?.scale || 1));
    keyboardTouch.x = touch.x;
    keyboardTouch.y = touch.y;
    scheduleDrawerUpdate();
  }

  function endKeyboardScroll(event) {
    const tappedField = event?.type === 'touchend' && keyboardTouch && !keyboardTouch.scrolling &&
      performance.now() - keyboardTouch.startedAt < 400 && event.target === getFocusedTextField() &&
      window.getSelection()?.type !== 'Range';
    keyboardTouch = null;
    if (tappedField) {
      keyboardHasAdjusted = false;
      scheduleDrawerUpdate();
    }
  }

  function cancelKeyboardAlignment() {
    if (keyboardAlignmentTimer) window.clearTimeout(keyboardAlignmentTimer);
    keyboardAlignmentTimer = 0;
  }

  function setKeyboardScrollEnabled(enabled) {
    if (keyboardScrollEnabled === enabled) return;
    keyboardScrollEnabled = enabled;
    const method = enabled ? 'addEventListener' : 'removeEventListener';
    document[method]('touchstart', startKeyboardScroll, { passive: true });
    document[method]('touchmove', moveKeyboardScroll, { passive: false });
    document[method]('touchend', endKeyboardScroll, { passive: true });
    document[method]('touchcancel', endKeyboardScroll, { passive: true });
    if (!enabled) {
      cancelKeyboardAlignment();
      endKeyboardScroll();
      releaseKeyboardPage();
    }
  }

  function getArtworkViewportTop() {
    const top = Math.max(0, visualViewport?.offsetTop || 0);
    const layoutHeight = Math.max(window.innerHeight, document.documentElement.clientHeight);
    // During body locking Safari briefly reports the old document scroll as an
    // offset. It is not a viewport pan and must not hide/release the drawer.
    if (isIOS && visualViewport && top > Math.max(0, layoutHeight - visualViewport.height) + 1) {
      const keyboardOpen = getFocusedTextField() &&
        visualViewport.height * (visualViewport.scale || 1) < layoutHeight - 120;
      return keyboardPageLock && keyboardOpen ? null : 0;
    }
    return top;
  }

  function alignDrawerToViewport() {
    // Fixed elements use layout-viewport coordinates while the keyboard can pan the visual viewport.
    // Apply this immediately on viewport scroll, including Safari where rAF can be suspended.
    const viewportTop = getArtworkViewportTop();
    if (viewportTop === null && !isIOS) return;
    // Safari's focused fixed layers can already include its native viewport pan.
    // Correct the rendered rectangle instead of adding that pan a second time.
    const renderedTop = isIOS && drawer?.classList.contains('is-visible')
      ? (parseFloat(drawer.style.getPropertyValue('--inkybox-artwork-drawer-top')) || 0) - drawer.getBoundingClientRect().top
      : (viewportTop || 0);
    const top = `${renderedTop}px`;
    drawer?.style.setProperty('--inkybox-artwork-drawer-top', top);
    zoomControls?.style.setProperty('--inkybox-artwork-drawer-top', top);
    closeButton?.style.setProperty('--inkybox-artwork-drawer-top', top);
    nativeHost?.style.setProperty('--inkybox-artwork-native-top', top);
  }

  function positionDrawerInViewport(viewportTop, viewportHeight) {
    const focusedTextField = getFocusedTextField();
    // Safari may shrink innerHeight again while panning a focused page; clientHeight
    // retains the layout viewport and prevents a false keyboard-close/relock cycle.
    const layoutHeight = Math.max(window.innerHeight, document.documentElement.clientHeight);
    const keyboardOpen = focusedTextField && viewportHeight * (visualViewport?.scale || 1) < layoutHeight - 120;
    const keyboardJustOpened = !keyboardWasOpen && keyboardOpen;
    const keyboardJustClosed = keyboardWasOpen && !keyboardOpen;
    keyboardWasOpen = Boolean(keyboardOpen);
    setKeyboardScrollEnabled(Boolean(keyboardOpen) && mobileQuery.matches);
    drawer?.classList.toggle('is-keyboard-active', Boolean(keyboardOpen));
    alignDrawerToViewport();
    if (!keyboardOpen) {
      keyboardAdjustedField = null;
      cancelKeyboardAlignment();
      keyboardHasAdjusted = false;
    } else {
      keyboardDismissedField = null;
      if (keyboardJustOpened || keyboardAdjustedField !== focusedTextField) {
        keyboardAdjustedField = focusedTextField;
        cancelKeyboardAlignment();
        keyboardHasAdjusted = false;
      }
    }
    return {
      focusedTextField: keyboardOpen ? focusedTextField : null,
      dismissedTextField: keyboardJustClosed ? focusedTextField : null,
    };
  }

  function keepFocusedFieldBelowDrawer(focusedTextField, drawerHeight, afterDismissal = false) {
    if (!focusedTextField) return;
    if (afterDismissal) {
      if (keyboardDismissedField === focusedTextField) return;
      keyboardDismissedField = focusedTextField;
    } else {
      if (keyboardAdjustedField !== focusedTextField) return;
      if (keyboardHasAdjusted || keyboardTouch?.scrolling) return;
    }
    const adjust = () => window.requestAnimationFrame(() => {
      keyboardAlignmentTimer = 0;
      if (getFocusedTextField() !== focusedTextField || !drawer?.classList.contains('is-visible')) return;
      if (!afterDismissal && (!keyboardScrollEnabled || keyboardHasAdjusted || keyboardTouch?.scrolling)) return;
      if (!afterDismissal && getArtworkViewportTop() === null) {
        keepFocusedFieldBelowDrawer(focusedTextField, drawerHeight);
        return;
      }
      alignDrawerToViewport();
      const drawerBottom = drawer?.getBoundingClientRect().bottom ?? drawerHeight;
      const fieldRect = focusedTextField.getBoundingClientRect();
      const targetTop = drawerBottom + 12;
      if (!afterDismissal) keyboardHasAdjusted = true;
      if (afterDismissal && fieldRect.top >= targetTop - 1) return;
      const delta = fieldRect.top - targetTop;
      if (Math.abs(delta) <= 1) return;
      scrollArtworkPageBy(delta);
      scheduleDrawerUpdate();
    });
    if (afterDismissal) adjust();
    else {
      cancelKeyboardAlignment();
      keyboardAlignmentTimer = window.setTimeout(adjust, 120);
    }
  }

  function showDrawer(viewportHeight, focusedTextField, dismissedTextField) {
    ensureDrawer();
    if (!artwork || !bindNativeArtwork()) {
      hideDrawer();
      return;
    }
    const drawerHeight = Math.min(
      260,
      (window.screen.height || viewportHeight) * 0.34,
      Math.max(120, viewportHeight - 96)
    );
    previewFrameWidth = window.innerWidth;
    previewFrameHeight = drawerHeight;
    const drawerHeightValue = `${drawerHeight}px`;
    drawer.style.setProperty('--inkybox-artwork-drawer-height', drawerHeightValue);
    zoomControls.style.setProperty('--inkybox-artwork-drawer-height', drawerHeightValue);
    nativeHost.style.setProperty('--inkybox-artwork-native-height', drawerHeightValue);
    nativeHost.style.setProperty('--inkybox-artwork-native-top', drawer.style.getPropertyValue('--inkybox-artwork-drawer-top') || '0px');
    drawer.removeAttribute('aria-hidden');
    drawer.classList.add('is-visible');
    lockKeyboardPage();
    alignDrawerToViewport();
    zoomControls.hidden = false;
    closeButton.hidden = false;
    applyPreviewTransform();
    keepFocusedFieldBelowDrawer(focusedTextField, drawerHeight);
    keepFocusedFieldBelowDrawer(dismissedTextField, drawerHeight, true);
  }

  function updateDrawer() {
    updateFrame = 0;
    if (document.hidden || !mobileQuery.matches || !anchor.classList.contains('inkybox-customall-media-loaded')) {
      setKeyboardScrollEnabled(false);
      hideDrawer();
      return;
    }

    const nextArtwork = anchor.querySelector('#artwork-preview');
    const nextForm = product.querySelector('#personalized-form');
    if (!nextArtwork || !nextForm) {
      setKeyboardScrollEnabled(false);
      hideDrawer();
      return;
    }
    if (artwork !== nextArtwork) {
      hideDrawer();
      artwork = nextArtwork;
      if (artworkObserver) artworkObserver.disconnect();
      artworkObserver = null;
      sentinel?.remove();
      sentinel = null;
    }
    if (form !== nextForm) {
      form = nextForm;
      if (formObserver) formObserver.disconnect();
      formObserver = null;
    }

    ensureDrawer();
    ensureSentinel();
    if (supportsIntersectionObserver && !artworkObserver && sentinel) {
      artworkObserver = new IntersectionObserver(scheduleDrawerUpdate);
      artworkObserver.observe(sentinel);
    }
    if (supportsIntersectionObserver && !formObserver && form) {
      formObserver = new IntersectionObserver(scheduleDrawerUpdate, { rootMargin: '-120px 0px 0px 0px' });
      formObserver.observe(form);
    }

    const viewportTop = getArtworkViewportTop();
    if (viewportTop === null) return;
    const viewportHeight = visualViewport ? visualViewport.height : window.innerHeight;
    const viewportBottom = viewportTop + viewportHeight;
    const viewportState = positionDrawerInViewport(viewportTop, viewportHeight);
    const sentinelRect = sentinel.getBoundingClientRect();
    if (sentinelRect.bottom > viewportTop) dismissed = false;

    const formRect = form.getBoundingClientRect();
    // Safari can leave the focused form just below the keyboard when body locking
    // removes its native pan. Let the existing one-time field alignment settle it
    // instead of hiding/unlocking and starting the same visibility cycle again.
    const formReachesViewport = formRect.top < viewportBottom || (isIOS && viewportState.focusedTextField);
    const shouldShow = !dismissed && sentinelRect.bottom <= viewportTop &&
      formReachesViewport && formRect.bottom > viewportTop + 120;
    if (shouldShow) showDrawer(viewportHeight, viewportState.focusedTextField, viewportState.dismissedTextField);
    else hideDrawer();
  }

  function runDrawerUpdate() {
    if (updateFrame) window.cancelAnimationFrame(updateFrame);
    if (updateFallbackTimer) window.clearTimeout(updateFallbackTimer);
    updateFrame = 0;
    updateFallbackTimer = 0;
    updateDrawer();
  }

  function scheduleDrawerUpdate() {
    if (updateFrame || updateFallbackTimer) return;
    updateFrame = window.requestAnimationFrame(runDrawerUpdate);
    updateFallbackTimer = window.setTimeout(runDrawerUpdate, 120);
  }

  const handoffObserver = new MutationObserver((mutations) => {
    const relevantChange = mutations.some((mutation) => {
      if (mutation.type === 'attributes') {
        return mutation.target === anchor || mutation.target.matches?.('.main-carousel .embla__slide') ||
          (mutation.target === nativeHost && !nativeHost.classList.contains('inkybox-customall-artwork-native-host')) ||
          (mutation.target === nativeStage && !nativeStage.classList.contains('inkybox-customall-artwork-native-stage'));
      }
      const changedNodes = [...Array.from(mutation.addedNodes || []), ...Array.from(mutation.removedNodes || [])];
      return changedNodes.some((node) => {
        return node.nodeType === 1 && (
          node.id === 'artwork-preview' ||
          node.matches?.('.main-carousel') ||
          node.matches?.('canvas') ||
          node.querySelector?.('#artwork-preview, .main-carousel, canvas')
        );
      });
    });
    if (relevantChange) scheduleDrawerUpdate();
  });
  handoffObserver.observe(anchor, {
    attributes: true,
    attributeFilter: ['class'],
    childList: true,
    subtree: true,
  });

  mobileQuery.addEventListener?.('change', scheduleDrawerUpdate);
  window.addEventListener('resize', scheduleDrawerUpdate);
  function handleVisualViewportChange() {
    alignDrawerToViewport();
    scheduleDrawerUpdate();
  }
  visualViewport?.addEventListener('resize', handleVisualViewportChange, { passive: true });
  visualViewport?.addEventListener('scroll', handleVisualViewportChange, { passive: true });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      setKeyboardScrollEnabled(false);
      hideDrawer();
      return;
    }
    scheduleDrawerUpdate();
  });
  window.addEventListener('resize', () => {
    previewFrameWidth = window.innerWidth;
    if (drawer) previewFrameHeight = drawer.clientHeight;
    if (zoomScale > minimumZoom) applyPreviewPan();
  });
  if (!supportsIntersectionObserver) window.addEventListener('scroll', scheduleDrawerUpdate, { passive: true });
  scheduleDrawerUpdate();
})();

(function initInkyboxCustomallPersonalizerLoadingState() {
  const shells = document.querySelectorAll('[data-inkybox-customall-personalizer]');
  if (!shells.length) return;

  shells.forEach((shell) => {
    const status = shell.querySelector('[data-inkybox-customall-personalizer-status]');
    let readyTimer = 0;

    const hasCompletePersonalizer = () => {
      const form = shell.querySelector('#personalized-form');
      if (!form) return false;
      return Boolean(
        form.querySelector('.ctm-customize-product') &&
        form.querySelector('.add-to-cart-group, button.btn-add-to-cart')
      );
    };

    const revealWhenStable = () => {
      window.clearTimeout(readyTimer);
      if (!hasCompletePersonalizer()) return;

      readyTimer = window.setTimeout(() => {
        if (!hasCompletePersonalizer() || shell.classList.contains('is-ready')) return;
        shell.classList.add('is-ready');
        shell.setAttribute('aria-busy', 'false');
        observer.disconnect();
      }, 120);
    };

    const observer = new MutationObserver(() => {
      revealWhenStable();
    });

    observer.observe(shell, { childList: true, subtree: true });
    revealWhenStable();

    window.setTimeout(() => {
      if (!shell.classList.contains('is-ready') && status) {
        status.textContent = 'Personalization is taking a little longer to load...';
      }
    }, 8000);
  });
})();

(function installInkyboxCustomallMediaDebug() {
  const params = new URLSearchParams(window.location.search || '');
  if (params.get('inkybox_debug_media') !== '1') return;

  const seen = new WeakSet();
  const describe = (node) => {
    if (!node || node.nodeType !== 1) return null;
    const attrs = ['id', 'class', 'src', 'href', 'data-src', 'data-media-id']
      .map((name) => {
        const value = node.getAttribute && node.getAttribute(name);
        return value ? `${name}="${String(value).slice(0, 180)}"` : '';
      })
      .filter(Boolean)
      .join(' ');
    return `<${node.tagName.toLowerCase()}${attrs ? ` ${attrs}` : ''}>`;
  };

  const collectMedia = () => {
    const selectors = [
      '[data-inkybox-customall-media-anchor]',
      '.product__media-wrapper',
      '.ctm-customize-product',
      '.customall-wrapper',
      'img[src]',
      'canvas',
      'iframe',
      'video',
      '[class*="preview"]',
      '[class*="media"]',
    ];
    return Array.from(document.querySelectorAll(selectors.join(',')))
      .map((node) => describe(node))
      .filter(Boolean);
  };

  const logSnapshot = (label) => {
    const anchor = document.querySelector('[data-inkybox-customall-media-anchor]');
    const customallRoot = document.querySelector('.ctm-customize-product, .customall-wrapper');
    console.log('[Inkybox media debug]', label, {
      anchor: describe(anchor),
      customallRoot: describe(customallRoot),
      mediaNodes: collectMedia().slice(0, 80),
    });
  };

  window.InkyboxMediaDebug = {
    snapshot: () => logSnapshot('manual snapshot'),
    mediaNodes: collectMedia,
  };

  logSnapshot('initial');
  window.addEventListener('load', () => logSnapshot('window load'));
  setTimeout(() => logSnapshot('after 1000ms'), 1000);
  setTimeout(() => logSnapshot('after 3000ms'), 3000);
  setTimeout(() => logSnapshot('after 6000ms'), 6000);

  new MutationObserver((mutations) => {
    const added = [];
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes || []) {
        if (!node || node.nodeType !== 1 || seen.has(node)) continue;
        seen.add(node);
        const text = describe(node);
        if (
          text &&
          /ctm|customall|preview|media|img|canvas|iframe|video|product__media/i.test(text)
        ) {
          added.push(text);
        }
      }
    }
    if (added.length) {
      console.log('[Inkybox media debug] mutation added', added.slice(0, 30));
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

(function initInkyboxAddonOfferControls() {
  if (window.__inkyboxAddonOfferControlsInstalled) return;
  window.__inkyboxAddonOfferControlsInstalled = true;

  function getProductInfoRoot(offer) {
    return (
      offer.closest('.product__info-container') ||
      document.querySelector('.product__info-container') ||
      offer.closest('.product__info-wrapper') ||
      document.querySelector('.product__info-wrapper') ||
      document
    );
  }

  function buttonTextMatchesPreview(button) {
    const text = String(button && button.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
    return text.includes('preview your personalized') || text.includes('preview your design') || text === 'preview';
  }

  function findPreviewTarget(root, offer) {
    if (!root) return null;
    const directButton = root.querySelector(
      'button.btn.btn-preview, #customily-preview-button, #sticky-customily-preview-button, button[id*="preview-button"], a[id*="preview-button"]'
    );

    const textButton = Array.from(root.querySelectorAll('button, a')).find(function (button) {
      if (offer.contains(button)) return false;
      return buttonTextMatchesPreview(button);
    });

    const button = directButton || textButton;
    if (!button || offer.contains(button)) return null;
    return (
      button.closest('.preview-actions') ||
      button.closest('.customily-preview-button-wrapper') ||
      button
    );
  }

  function placeOffer() {
    const offers = Array.from(document.querySelectorAll('[data-inkybox-addon-offer]'));
    if (!offers.length) return;

    const root = getProductInfoRoot(offers[0]);
    const previewTarget = findPreviewTarget(root, offers[0]);
    if (previewTarget) {
      offers.forEach(function (offer) {
        if (previewTarget.previousElementSibling !== offer) {
          previewTarget.parentElement.insertBefore(offer, previewTarget);
        }
        offer.classList.add('inkybox-addon-offer--placed');
      });
    }
  }

  function clampQuantity(input) {
    if (!input) return 1;
    const value = Math.max(1, Number(input.value || 1) || 1);
    input.value = String(value);
    return value;
  }

  function setQuantity(input, value) {
    if (!input) return;
    input.value = String(Math.max(1, Number(value || 1) || 1));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('click', function (event) {
    const offer = event.target.closest('[data-inkybox-addon-offer]');
    if (!offer) return;

    const input = offer.querySelector('[data-addon-qty]');
    if (event.target.closest('[data-addon-minus]')) {
      event.preventDefault();
      setQuantity(input, clampQuantity(input) - 1);
      return;
    }

    if (event.target.closest('[data-addon-plus]')) {
      event.preventDefault();
      setQuantity(input, clampQuantity(input) + 1);
    }
  });

  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches('[data-addon-qty]')) clampQuantity(event.target);
  });

  document.addEventListener('DOMContentLoaded', function () {
    const offers = Array.from(document.querySelectorAll('[data-inkybox-addon-offer]'));
    if (!offers.length) return;

    const root = getProductInfoRoot(offers[0]);
    const previewSelector =
      'button.btn.btn-preview, #customily-preview-button, #sticky-customily-preview-button, button[id*="preview-button"], a[id*="preview-button"]';
    let observer = null;
    let placementFrame = 0;
    let finished = false;
    let fallbackTimer = 0;

    const allPlaced = function () {
      return offers.every(function (offer) {
        return offer.classList.contains('inkybox-addon-offer--placed');
      });
    };

    const cleanup = function () {
      if (finished) return;
      finished = true;
      if (observer) observer.disconnect();
      window.clearTimeout(fallbackTimer);
    };

    const attemptPlacement = function () {
      placementFrame = 0;
      placeOffer();
      if (allPlaced()) cleanup();
    };

    const schedulePlacement = function () {
      if (finished || placementFrame) return;
      placementFrame = window.requestAnimationFrame(attemptPlacement);
    };

    const containsPreviewControl = function (node) {
      if (!node || node.nodeType !== 1) return false;
      if (node.matches(previewSelector) || node.querySelector(previewSelector)) return true;
      const buttons = node.matches('button, a') ? [node] : Array.from(node.querySelectorAll('button, a'));
      return buttons.some(buttonTextMatchesPreview);
    };

    observer = new MutationObserver(function (mutations) {
      const previewChanged = mutations.some(function (mutation) {
        const target = mutation.target && mutation.target.nodeType === 1
          ? mutation.target
          : mutation.target && mutation.target.parentElement;
        if (target) {
          const targetButton = target.matches('button, a') ? target : target.closest('button, a');
          if (targetButton && buttonTextMatchesPreview(targetButton)) return true;
        }
        return Array.from(mutation.addedNodes || []).some(containsPreviewControl);
      });
      if (previewChanged) schedulePlacement();
    });
    observer.observe(root, { childList: true, subtree: true });

    fallbackTimer = window.setTimeout(function () {
      placeOffer();
      offers.forEach(function (offer) {
        if (!offer.classList.contains('inkybox-addon-offer--placed')) {
          offer.classList.add('inkybox-addon-offer--placed');
        }
      });
      cleanup();
    }, 10000);

    schedulePlacement();
  });
})();

(function installGiftBoxRequestMerger() {
  if (window.__inkyboxGiftBoxRequestMergerInstalled) return;
  window.__inkyboxGiftBoxRequestMergerInstalled = true;

  function isCartAddUrl(rawUrl) {
    const value = String(rawUrl || '');
    if (!value) return false;
    try {
      const url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin) return false;
      return url.pathname === '/cart/add.js' || url.pathname === '/cart/add';
    } catch (error) {
      return value.includes('/cart/add.js') || value.includes('/cart/add');
    }
  }

  function readAddonConfigs() {
    return Array.from(document.querySelectorAll('[data-inkybox-addon-offer]'))
      .map(function (box) {
        const checkbox = box.querySelector('[data-addon-checkbox]');
        if (!checkbox || !checkbox.checked) return null;
        const variantId = Number(box.dataset.addonVariantId);
        if (!variantId) return null;
        const allowQuantity = box.dataset.allowQuantity === 'true';
        const qtyInput = box.querySelector('[data-addon-qty]');
        const selectedQuantity = Math.max(1, Number(qtyInput && qtyInput.value || 1) || 1);
        return {
          variantId,
          allowQuantity,
          selectedQuantity,
          addonType: box.dataset.addonType || 'addon',
        };
      })
      .filter(Boolean);
  }

  function makeGroupKey() {
    return `inkybox-${Date.now()}-${Math.floor(Math.random() * 100000)}`;
  }

  function normalizeProperties(properties) {
    if (!properties) return {};
    if (typeof properties === 'object' && !Array.isArray(properties)) return Object.assign({}, properties);
    if (typeof properties === 'string') {
      try {
        const parsed = JSON.parse(properties);
        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) return parsed;
      } catch (error) {}
    }
    return {};
  }

  function getItemVariantId(item) {
    return Number(item && (item.id || item.variant_id));
  }

  function getItemQuantity(item) {
    return Math.max(1, Number(item && item.quantity ? item.quantity : 1) || 1);
  }

  function isAddonPayloadItem(item) {
    if (!item) return false;
    const props = normalizeProperties(item.properties);
    return (
      props._inkybox_item_type === 'addon' ||
      props._inkybox_parent_key ||
      props._parentKey ||
      props._parentLineKey ||
      props._is_addon === 'true'
    );
  }

  function isAddonPayloadVariant(item, addonVariantId) {
    return Number(getItemVariantId(item)) === Number(addonVariantId);
  }

  function cloneTopLevelExtras(originalPayload) {
    const extras = {};
    if (!originalPayload || typeof originalPayload !== 'object') return extras;
    if (originalPayload.sections) extras.sections = originalPayload.sections;
    if (originalPayload.sections_url) extras.sections_url = originalPayload.sections_url;
    return extras;
  }

  function attachGiftBoxToJsonPayload(originalPayload) {
    const configs = readAddonConfigs();
    if (!configs.length || !originalPayload) return null;

    let items = [];
    if (Array.isArray(originalPayload.items)) items = originalPayload.items.map((item) => Object.assign({}, item || {}));
    else if (originalPayload.id || originalPayload.variant_id) items = [Object.assign({}, originalPayload)];
    else return null;

    const mainItem = items.find(function (item) {
      return !isAddonPayloadItem(item);
    });
    if (!mainItem) return null;

    const groupKey = makeGroupKey();
    mainItem.properties = Object.assign({}, normalizeProperties(mainItem.properties), {
      _inkybox_item_type: 'main',
      _inkybox_group_key: groupKey,
      _itemKey: groupKey,
    });

    const mainQuantity = getItemQuantity(mainItem);
    configs.forEach(function (config) {
      if (items.some((item) => isAddonPayloadVariant(item, config.variantId))) return;
      items.push({
        id: config.variantId,
        quantity: config.allowQuantity ? config.selectedQuantity : mainQuantity,
        properties: {
          _inkybox_item_type: 'addon',
          _inkybox_addon_type: config.addonType,
          _inkybox_parent_key: groupKey,
          _parentKey: groupKey,
          _is_addon: 'true',
          _addon_type: config.addonType,
        },
      });
    });

    return Object.assign({}, cloneTopLevelExtras(originalPayload), { items });
  }

  function formDataToJsonPayload(formData) {
    if (!formData || typeof formData.get !== 'function') return null;
    const payload = {
      id: Number(formData.get('id')),
      quantity: Math.max(1, Number(formData.get('quantity') || 1) || 1),
      properties: {},
    };
    const sections = formData.get('sections');
    const sectionsUrl = formData.get('sections_url');
    if (sections) payload.sections = sections;
    if (sectionsUrl) payload.sections_url = sectionsUrl;
    for (const pair of formData.entries()) {
      const match = String(pair[0]).match(/^properties\[(.+)\]$/);
      if (match && match[1]) payload.properties[match[1]] = pair[1];
    }
    return payload.id ? payload : null;
  }

  function urlSearchParamsToJsonPayload(params) {
    if (!params || typeof params.get !== 'function') return null;
    const payload = {
      id: Number(params.get('id')),
      quantity: Math.max(1, Number(params.get('quantity') || 1) || 1),
      properties: {},
    };
    const sections = params.get('sections');
    const sectionsUrl = params.get('sections_url');
    if (sections) payload.sections = sections;
    if (sectionsUrl) payload.sections_url = sectionsUrl;
    for (const pair of params.entries()) {
      const match = String(pair[0]).match(/^properties\[(.+)\]$/);
      if (match && match[1]) payload.properties[match[1]] = pair[1];
    }
    return payload.id ? payload : null;
  }

  function tryBuildMergedBody(body) {
    let originalPayload = null;
    if (!body) return null;
    if (typeof body === 'string') {
      const trimmed = body.trim();
      if (trimmed.startsWith('{')) {
        try {
          originalPayload = JSON.parse(trimmed);
        } catch (error) {
          return null;
        }
      } else {
        originalPayload = urlSearchParamsToJsonPayload(new URLSearchParams(trimmed));
      }
    } else if (body instanceof FormData) {
      originalPayload = formDataToJsonPayload(body);
    } else if (body instanceof URLSearchParams) {
      originalPayload = urlSearchParamsToJsonPayload(body);
    } else {
      return null;
    }

    const mergedPayload = attachGiftBoxToJsonPayload(originalPayload);
    if (!mergedPayload) return null;
    return JSON.stringify(mergedPayload);
  }

  function mergeHeaders(headers) {
    const next = new Headers(headers || {});
    next.set('Content-Type', 'application/json');
    next.set('Accept', 'application/json');
    return next;
  }

  function showPopupFromCartAddResponse(response) {
    if (!response || !response.ok || typeof response.clone !== 'function') return;
    response.clone().json()
      .then((payload) => {
        if (!payload) return;
        if (payload.status) {
          inkyboxShowAddToCartError(payload.description || payload.message || 'We could not add this item to your cart. Please try again.');
          return;
        }
        window.__inkyboxCurrentPagePreviewUrl = inkyboxGetCurrentPagePreviewUrl();
        showInkyboxAddToCartPopup(payload);
      })
      .catch(() => {});
  }

  function showPopupFromCartAddText(text) {
    if (!text) return;
    try {
      const payload = JSON.parse(text);
      if (!payload) return;
      if (payload.status) {
        inkyboxShowAddToCartError(payload.description || payload.message || 'We could not add this item to your cart. Please try again.');
        return;
      }
      window.__inkyboxCurrentPagePreviewUrl = inkyboxGetCurrentPagePreviewUrl();
      showInkyboxAddToCartPopup(payload);
    } catch (error) {}
  }

  const originalFetch = window.fetch && window.fetch.bind(window);
  if (originalFetch) {
    window.fetch = function inkyboxGiftBoxFetch(input, init) {
      const rawUrl = typeof input === 'string' ? input : input && input.url;
      if (!isCartAddUrl(rawUrl)) return originalFetch(input, init);
      const method = String(init && init.method || input && input.method || 'POST').toUpperCase();
      if (method === 'GET' || method === 'HEAD') return originalFetch(input, init);
      const body = init && 'body' in init ? init.body : input && input.body;
      const mergedBody = tryBuildMergedBody(body);
      inkyboxOpenAddToCartLoadingPopup();
      if (!mergedBody) {
        return originalFetch(input, init).then((response) => {
          showPopupFromCartAddResponse(response);
          if (!response || !response.ok) inkyboxShowAddToCartError('We could not add this item to your cart. Please try again.');
          return response;
        }).catch((error) => {
          inkyboxShowAddToCartError('We could not add this item to your cart. Please try again.');
          throw error;
        });
      }
      const nextInit = Object.assign({}, init || {}, {
        method: 'POST',
        body: mergedBody,
        headers: mergeHeaders(init && init.headers || input && input.headers),
      });
      return originalFetch(rawUrl || input, nextInit).then((response) => {
        showPopupFromCartAddResponse(response);
        if (!response || !response.ok) inkyboxShowAddToCartError('We could not add this item to your cart. Please try again.');
        return response;
      }).catch((error) => {
        inkyboxShowAddToCartError('We could not add this item to your cart. Please try again.');
        throw error;
      });
    };
  }

  if (window.XMLHttpRequest) {
    const OriginalXHR = window.XMLHttpRequest;
    window.XMLHttpRequest = function InkyboxXMLHttpRequest() {
      const xhr = new OriginalXHR();
      let requestUrl = '';
      let requestMethod = 'GET';
      const originalOpen = xhr.open;
      const originalSend = xhr.send;

      xhr.open = function (method, url) {
        requestMethod = String(method || 'GET').toUpperCase();
        requestUrl = url;
        return originalOpen.apply(xhr, arguments);
      };

      xhr.send = function (body) {
        if (isCartAddUrl(requestUrl) && requestMethod !== 'GET' && requestMethod !== 'HEAD') {
          inkyboxOpenAddToCartLoadingPopup();
          xhr.addEventListener('load', function () {
            if (xhr.status >= 200 && xhr.status < 300) {
              showPopupFromCartAddText(xhr.responseText);
            } else {
              inkyboxShowAddToCartError('We could not add this item to your cart. Please try again.');
            }
          });
          xhr.addEventListener('error', function () {
            inkyboxShowAddToCartError('We could not add this item to your cart. Please try again.');
          });
          const mergedBody = tryBuildMergedBody(body);
          if (mergedBody) {
            try {
              xhr.setRequestHeader('Content-Type', 'application/json');
              xhr.setRequestHeader('Accept', 'application/json');
            } catch (error) {}
            return originalSend.call(xhr, mergedBody);
          }
        }
        return originalSend.apply(xhr, arguments);
      };

      return xhr;
    };
    window.XMLHttpRequest.prototype = OriginalXHR.prototype;
  }
})();
